module.exports = __webpack_public_path__ + "static/media/8.2cc6ef41.jpg";